import React, { useState, useEffect } from "react";
import "./App.css";
import { sortByCases, prettyPrintStat } from "./util";
import {
  FormControl,
  Select,
  MenuItem,
  Card,
  CardContent,
} from "@material-ui/core";
import axios from "./axios";
import requests from "./requests";
import Infobox from "./Infobox";
import Map from "./Map";
import Table from "./Table";
import LineGraph from "./LineGraph";
import "leaflet/dist/leaflet.css";
import Logo from "./opinion.jpeg";

function App() {
  const [countries, setCountries] = useState([]);
  const [country, setCountry] = useState("worldwide");
  const [countryDetails, setCountryDetails] = useState({});
  const [countriesData, setCountriesData] = useState([]);
  const [mapCenter, setMapCenter] = useState({
    lat: 41.1495836,
    lng: 18.9685238,
  });
  const [mapZoom, setMapZoom] = useState(3);
  const [mapCountries, setMapCountries] = useState([]);
  const [casesType, setCasesType] = useState("cases");

  useEffect(() => {
    getAllCountries();
  }, []);

  useEffect(() => {
    getSingleCountry(country);
  }, [country]);

  const handleChange = (event) => {
    const countryCode = event.target.value;
    setCountry(countryCode);
    //getSingleCountry(countryCode);
  };

  const getAllCountries = () => {
    axios
      .get(requests.allCountries)
      .then(function (response) {
        // handle success

        console.log(response);
        let allCountries = [];
        let countriesData = [];
        response.data.map((country) => {
          allCountries.push({
            name: country.country,
            value: country.countryInfo.iso2,
          });

          countriesData.push({
            country: country.country,
            cases: country.cases,
            flag: country.countryInfo.flag,
          });
        });

        setCountries(allCountries);

        setMapCountries(response.data);

        sortByCases(countriesData);
        setCountriesData(countriesData);
      })
      .catch(function (error) {
        // handle error
        console.log(error);
      });
  };

  const getSingleCountry = (country) => {
    const url =
      country !== "worldwide"
        ? `${requests.allCountries}/${country}`
        : `${requests.allCountriesData}`;

    axios
      .get(url)
      .then(function (response) {
        // handle success
        const countryDetails = response.data;
        setCountryDetails(countryDetails);

        setMapCenter({
          lat: countryDetails.countryInfo.lat,
          lng: countryDetails.countryInfo.long,
        });

        setMapZoom(7);
      })
      .catch(function (error) {
        // handle error
        console.log(error);
      });
  };

  return (
    <div className="app">
      <div className="app__left">
        <div className="app__header">
          {/* <h1>COVID-19 TRACKER</h1> */}
          <img src={Logo} alt="Opinion" className="app__logo" />
          <FormControl className="app__dropdown">
            <Select
              placeholder="Select a contry"
              variant="outlined"
              value={country}
              onChange={handleChange}
            >
              <MenuItem value="worldwide">Worldwide</MenuItem>
              {countries.map((country, index) => (
                <MenuItem key={index} value={country.value}>
                  {country.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
        {/* Header -> Title + dropdown */}

        <div className="app__stats">
          <Infobox
            isRed
            active={casesType === "cases"}
            onClick={(e) => setCasesType("cases")}
            title="Coronavirus Cases"
            totalCases={prettyPrintStat(countryDetails.cases)}
            cases={prettyPrintStat(countryDetails.todayCases)}
          />

          <Infobox
            active={casesType === "recovered"}
            onClick={(e) => setCasesType("recovered")}
            title="Recovered"
            totalCases={prettyPrintStat(countryDetails.recovered)}
            cases={prettyPrintStat(countryDetails.todayRecovered)}
          />

          <Infobox
            isRed
            active={casesType === "deaths"}
            onClick={(e) => setCasesType("deaths")}
            title="Deaths"
            totalCases={prettyPrintStat(countryDetails.deaths)}
            cases={prettyPrintStat(countryDetails.todayDeaths)}
          />
        </div>

        <Map
          casesType={casesType}
          countries={mapCountries}
          center={mapCenter}
          zoom={mapZoom}
        />

        <div className="app__down">
          <div className="app__stats">
            <Infobox
              isBlue
              title="Active Cases"
              // totalCases={prettyPrintStat(countryDetails.cases)}
              cases={prettyPrintStat(countryDetails.active)}
            />

            <Infobox
              isBlue
              title="Critical Cases"
              // totalCases={prettyPrintStat(countryDetails.cases)}
              cases={prettyPrintStat(countryDetails.critical)}
            />

            <Infobox
              isBlue
              title="Tests"
              // totalCases={prettyPrintStat(countryDetails.cases)}
              cases={prettyPrintStat(countryDetails.tests)}
            />
          </div>
        </div>
      </div>

      <Card className="app__right">
        <CardContent>
          <h3 className="app__titleCases">Live Cases by Country</h3>
          <Table countries={countriesData} />
          <h3 className="app__graphTitle">Worldwide new cases</h3>

          <LineGraph className="app__graph" casesType={casesType} />
        </CardContent>
      </Card>
    </div>
  );
}

export default App;

// 4:15
